<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<!-- Sub header -->
@if (cfg().allowGalleryMode && cfg().allowTableMode) {
  <nav class="sub-header">
    <!-- View mode buttons -->
    <div class="container-lg">
      <div class="d-flex justify-content-center justify-content-lg-end">
        <button
          type="button"
          class="btn btn-link btn-view-mode p-0 mr-2"
          (click)="goToGallery()"
          [ngClass]="isGalleryMode ? 'active' : ''"
          >
          <img src="assets/images/boxes-view-icon.svg" alt="Boxes view" />
          <img class="active" src="assets/images/boxes-view-icon-yellow.svg" alt="Boxes view" />
        </button>
        <button
          type="button"
          class="btn btn-link btn-view-mode p-0"
          (click)="goToTable()"
          [ngClass]="!isGalleryMode ? 'active' : ''"
          >
          <img src="assets/images/list-view-icon.svg" alt="List view" />
          <img class="active" src="assets/images/list-view-icon-yellow.svg" alt="List view" />
        </button>
      </div>
    </div>
  </nav>
}

<div class="row">
  <div class="col-12">
    <section class="category-gallery-page pt-4">
      <!-- Search -->
      @if (!cfg().hideSearch) {
        <div class="search-bar">
          <form name="searchForm" #searchForm="ngForm">
            <div class="form-group has-search">
              <img
                class="form-control-feedback"
                src="assets/images/search-icon.svg"
                alt="Search icon"
                />
              <input
                type="text"
                class="form-control"
                id="page-search-bar"
                name="page-search-bar"
                #searchInput
                [placeholder]="cfg().searchPlaceholder"
                [(ngModel)]="searchTerm"
                />
            </div>
          </form>
        </div>
      }
      <!-- Loader -->
      @if (isLoading) {
        <app-loader></app-loader>
      }

      @if (!isLoading) {
        <!-- Grid view -->
        @if (isGalleryMode) {
          <div class="row">
            <!-- Create new -->
            @if (cfg().allowCreate) {
              <div class="col-6 col-lg-3">
                <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                <a class="text-decoration-none" (click)="createItem()">
                  <div class="gallery-item gallery-item-create-new">
                    <div class="image-holder">
                      <img
                        class="image"
                      [src]="
                        cfg().gallerySettings?.createButtonImage
                          ? cfg().gallerySettings?.createButtonImage
                          : 'assets/images/placeholder-category.png'
                      "
                        alt="Create new"
                        />
                      <!-- addon for create new -->
                      <div class="create-new">
                        <p>{{ cfg().createButtonText ? cfg().createButtonText : 'New' }}</p>
                      </div>
                    </div>
                    <div class="title-holder"></div>
                  </div>
                </a>
              </div>
            }
            @for (currDataItem of data; track currDataItem) {
              <div class="col-6 col-lg-3">
                <ng-template #galleryItem>
                  <div class="gallery-item">
                    <div class="image-holder">
                      <img
                        class="image"
                        src="assets/images/placeholder-category.png"
                        alt="Category image"
                        />
                      @if (cfg().allowEdit) {
                        <button
                          type="button"
                          class="edit-btn"
                          (click)="editItem(currDataItem)"
                          >
                          <img
                            class="edit-icon"
                            src="assets/images/edit-icon-dark.svg"
                            alt="Edit icon"
                            />
                        </button>
                      }
                    </div>
                    <div class="title-holder">
                      <p class="title">{{ currDataItem[cfg().gallerySettings!.nameProperty] }}</p>
                    </div>
                  </div>
                </ng-template>
                @if (cfg().gallerySettings?.linkFunc) {
                  <a
                    class="text-decoration-none"
                    [routerLink]="getItemGalleryLink(currDataItem)"
                    >
                    <ng-container *ngTemplateOutlet="galleryItem"></ng-container>
                  </a>
                }
                @if (!cfg().gallerySettings?.linkFunc) {
                  <a class="text-decoration-none">
                    <ng-container *ngTemplateOutlet="galleryItem"></ng-container>
                  </a>
                }
              </div>
            }
          </div>
        }
        <!-- Table view -->
        @if (!isGalleryMode) {
          <!-- Actions -->
          <div class="actions-bar my-3">
            @if (cfg().allowCreate) {
              <button
                type="button"
                class="btn btn-yellow btn-sm mr-2"
                (click)="createItem()"
                >
                {{ cfg().createButtonText }}
              </button>
            }
            <!-- Custom Actions -->
            <ng-template *ngTemplateOutlet="actionsContentTpl()?.templateRef ?? null">
            </ng-template>
          </div>
          <!-- Table -->
          <div class="table-responsive">
            <table class="table table-style-3 table-branches">
              <thead>
                <tr>
                  @if (itemLeadingActionsContentTpl()) {
                    <th>
                      <!-- leading actions -->
                    </th>
                  }
                  @if (cfg().showActiveState) {
                    <th>פעיל</th>
                  }
                  <!-- clases .asc and .desc are for example they will be added automaticly when table will be sortable -->
                  @for (currColumn of cfg().tableSettings?.columns; track currColumn) {
                    <th
                      class="sortable"
                      (click)="sortByColumn(currColumn)"
                    [ngClass]="{
                      asc: currColumn.name === sortColumn && !sortDescending,
                      desc: currColumn.name === sortColumn && sortDescending,
                    }"
                      >
                      {{ currColumn.displayText }}
                    </th>
                  }
                  @if (cfg().allowEdit || itemActionsContentTpl()) {
                    <th>
                      <!-- edit -->
                    </th>
                  }
                  @if (cfg().tableSettings?.showExpand) {
                    <th>
                      <!-- expand -->
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                <!-- Items -->
                @for (currDataItem of data; track currDataItem; let i = $index) {
                  <!-- Row -->
                  <tr [ngClass]="{ inactive: cfg().showActiveState && !currDataItem['active'] }">
                    @if (itemLeadingActionsContentTpl()) {
                      <td>
                        <ng-template
                          *ngTemplateOutlet="
                            itemLeadingActionsContentTpl()?.templateRef ?? null;
                            context: { item: currDataItem, index: i }
                          "
                          >
                        </ng-template>
                      </td>
                    }
                    @if (cfg().showActiveState) {
                      <td>
                        <span
                          class="circle"
                        [ngClass]="{
                          active: currDataItem['active'],
                          inactive: !currDataItem['active'],
                        }"
                        ></span>
                      </td>
                    }
                    @for (currColumn of cfg().tableSettings?.columns; track currColumn) {
                      <td>
                        <ng-template #textContent>
                          @if (currColumn.parser) {
                            {{ currColumn.parser(currDataItem) }}
                          } @else {
                            @switch (currColumn.columnType) {
                              @case (ListViewTableColumnType.DateTime) {
                                {{
                                formatDateTime(currDataItem[currColumn.name], currColumn)
                                }}
                              }
                              @case (ListViewTableColumnType.Date) {
                                {{
                                formatDate(currDataItem[currColumn.name], currColumn)
                                }}
                              }
                              @case (ListViewTableColumnType.Boolean) {
                                {{ formatBoolean(currDataItem[currColumn.name]) }}
                              }
                              @case (ListViewTableColumnType.Image) {
                                @if (getImagePath(currDataItem, currColumn.name); as imagePath) {
                                  <img
                                    [src]="imagePath"
                                    [height]="60"
                                    alt="Image"
                                    />
                                }
                              }
                              @default {
                                {{
                                formatDefaultText(currDataItem[currColumn.name], currColumn)
                                }}
                              }
                            }
                          }
                        </ng-template>
                        @if (currColumn.linkFunc) {
                          <a
                            [routerLink]="getItemColumnLink(currDataItem, currColumn)"
                            >
                            <ng-container *ngTemplateOutlet="textContent"></ng-container>
                          </a>
                        }
                        @if (!currColumn.linkFunc) {
                          <ng-container *ngTemplateOutlet="textContent"></ng-container>
                        }
                      </td>
                    }
                    @if (cfg().allowEdit || itemActionsContentTpl()) {
                      <td
                        class="d-flex justify-content-end"
                        >
                        @if (cfg().allowEdit) {
                          <button type="button" class="btn btn-link p-0">
                            @if (isShopifyIntegratedStore(currDataItem)) {
                              <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                              <img
                                src="assets/images/reload-icon.svg"
                                alt="Sync Catalog"
                                placement="top"
                                [ngbTooltip]="getSyncIconTooltip(currDataItem)"
                                tooltipClass="tooltipWithLineBreaks"
                                (click)="syncIntergrationData(currDataItem)"
                                />
                            } @else {
                              <div style="width: 35px"></div>
                            }
                          </button>
                        }
                        @if (cfg().allowEdit) {
                          <button type="button" class="btn btn-link p-0">
                            <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                            <img
                              src="assets/images/edit-icon-light.svg"
                              alt="Edit btn"
                              (click)="editItem(currDataItem)"
                              />
                          </button>
                        }
                        <ng-template
                        *ngTemplateOutlet="
                          itemActionsContentTpl()?.templateRef ?? null;
                          context: { item: currDataItem, index: i }
                        "
                          >
                        </ng-template>
                      </td>
                    }
                    @if (cfg().tableSettings?.showExpand) {
                      <td
                        class="td-expand"
                        (click)="expandItem(currDataItem)"
                        >
                        <span class="text">More details</span>
                        <span
                          class="collapse-icon d-inline-block ml-lg-3"
                          [attr.expanded]="currDataItem.expanded"
                        ></span>
                      </td>
                    }
                  </tr>
                  <!-- Row collapse -->
                  @if (cfg().tableSettings?.showExpand) {
                    <tr
                      [ngbCollapse]="!currDataItem.expanded"
                      class="tr-collapse"
                      >
                      @if (currDataItem.loaded) {
                        <td [attr.colspan]="getExpandColspan()">
                          <ng-template
                        *ngTemplateOutlet="
                          expandContentTpl()?.templateRef ?? null;
                          context: { item: currDataItem, index: i }
                        "
                            >
                          </ng-template>
                        </td>
                      }
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        }
      }

      <!--      <nav aria-label="Table pagination">-->
      <!--        <ul class="pagination justify-content-center mt-3">-->
      <!--          <li class="page-item">-->
      <!--            <button type="button" class="page-link" aria-label="First" (click)="goToPage(0)">-->
      <!--              <span aria-hidden="true">&laquo;&laquo;</span>-->
    <!--            </button>-->
  <!--          </li>-->
  <!--          <li class="page-item">-->
  <!--            <button type="button" class="page-link" aria-label="Previous" [disabled]="pageIndex === 0" (click)="prevPage()">-->
  <!--              <span aria-hidden="true">&laquo;</span>-->
<!--            </button>-->
<!--          </li>-->
<!--          <li class="page-item" *ngFor="let currPageIndex of pages" [ngClass]="{'active': currPageIndex === pageIndex}">-->
<!--            <button type="button" class="page-link" (click)="goToPage(currPageIndex)">{{currPageIndex + 1}}</button>-->
<!--          </li>-->
<!--          <li class="page-item">-->
<!--            <button type="button" class="page-link" aria-label="Next" [disabled]="pageIndex >= (pageCount - 1)" (click)="nextPage()">-->
<!--              <span aria-hidden="true">&raquo;</span>-->
<!--            </button>-->
<!--          </li>-->
<!--          <li class="page-item">-->
<!--            <button type="button" class="page-link" aria-label="Last" (click)="goToPage(pageCount - 1)">-->
<!--              <span aria-hidden="true">&raquo;&raquo;</span>-->
<!--            </button>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </nav>-->
</section>
</div>
</div>
